export default __webpack_public_path__ + "static/media/wh_ep2_accuse_hacker.33c8e728.jpg";